import { AutogenModelEftFileNumber, AutogenRowEftFileNumber } from "./autogen/AutogenModelEftFileNumber";

export class ModelEftFileNumber extends AutogenModelEftFileNumber<RowEftFileNumber> {
	constructor() {
		super(RowEftFileNumber);
	}
}

export class RowEftFileNumber extends AutogenRowEftFileNumber {
}